<template>
  <div>
    <div v-if="boardItem.boardItemStatus === statusType.Information">
      <!-- Valid From -->
      <div>
        <div class="label mt-4 mb-1 d-flex justify-content-between align-items-center">
          <div>From</div>
        </div>
        <board-item-date-picker v-model="fromDate"></board-item-date-picker>
      </div>

      <!-- Valid To -->
      <div>
        <div class="label mt-4 mb-1 d-flex justify-content-between align-items-center">
          <div>To</div>
        </div>

        <board-item-date-picker v-model="toDate"></board-item-date-picker>
      </div>
    </div>

    <!-- Due and Planned date -->
    <div v-else>
      <div class="label mt-4 mb-1 d-flex justify-content-between align-items-center">
        <div class="d-flex justify-content-between align-items-center">
          <div
            class="cursor-pointer"
            @click="selectedDate = !disabled ? 'due' : 'due'"
            :class="{ 'font-weight-bold': dueSelected && displayPlannedDate }"
          >
            Due
          </div>
          <div class="ml-1 mr-1" v-if="displayPlannedDate">|</div>
          <div
            class="cursor-pointer"
            v-if="displayPlannedDate"
            @click="selectedDate = !disabled ? 'planned' : 'due'"
            :class="{ 'font-weight-bold': plannedSelected }"
          >
            Planned
          </div>
        </div>
        <div v-if="dueSelected"><DueBadge :item="boardItem" :only-overdue="true"></DueBadge></div>
      </div>

      <div v-if="dueSelected">
        <board-item-date-picker v-model="dueDate" :disabled="disabled" />
      </div>
      <div v-if="plannedSelected">
        <board-item-date-picker v-model="plannedDate" :disabled="disabled" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { Prop, Watch } from 'vue-property-decorator';
  import { IBoardItemDto, BoardItemStatusDto } from '@/apiclient/apiclient_generated';
  import DueBadge from '@/components/DueBadge.vue';
  import IBoardItemDates from '@/types/boardItemDates';

  @Component({
    components: { DueBadge },
  })
  export default class BoardItemDate extends Vue {
    @Prop()
    boardItem: IBoardItemDto;
    @Prop()
    displayPlannedDate: boolean;

    @Prop()
    disabled: boolean;

    statusType = BoardItemStatusDto;

    private selectedDate = '';

    private dueDate = null;
    private plannedDate = null;
    private fromDate = null;
    private toDate = null;

    private enableWatch = false;

    get dueSelected() {
      return this.selectedDate === 'due';
    }

    @Watch('dueDate')
    changeDueDate() {
      this.pushUpdates();
    }

    @Watch('plannedDate')
    changePlannedDate() {
      this.pushUpdates();
    }

    @Watch('fromDate')
    changeFromDate() {
      this.pushUpdates();
    }

    @Watch('toDate')
    changeToDate() {
      this.pushUpdates();
    }

    get plannedSelected() {
      return this.selectedDate === 'planned' && this.displayPlannedDate;
    }

    async selectDate(selection) {
      if (selection === null) {
        await this.pushUpdates();
      }
    }

    async mounted() {
      this.fromDate = this.boardItem.validFromDate;
      this.toDate = this.boardItem.validToDate;
      this.dueDate = this.boardItem.dueDate;
      this.plannedDate = this.boardItem.plannedDate;
      this.selectedDate = 'due';

      await this.$nextTick();
      this.enableWatch = true;
    }

    private async pushUpdates() {
      if (this.enableWatch) {
        await this.$emit('boardItemDateUpdated', this.getBoardItemDates());
      }
    }

    private getBoardItemDates(): IBoardItemDates {
      return {
        validFromDate: this.fromDate,
        validToDate: this.toDate,
        dueDate: this.dueDate,
        plannedDate: this.plannedDate,
      } as IBoardItemDates;
    }
  }
</script>

<style scoped lang="scss">
  .bi-badge {
    width: 100%;
  }

  .font-weight-bold {
    font-weight: 800 !important;
  }
</style>
